import {
    AssessmentInstructionEnglishParent,
    AssessmentInstructionEnglishTeacher,
    AssessmentInstructionEnglishSelf,
    AssessmentInstructionFrenchParent,
    AssessmentInstructionFrenchTeacher,
    AssessmentInstructionFrenchSelf,
    AssessmentInstructionSpanishParent,
    AssessmentInstructionSpanishSelf,
    AssessmentOmission,
    AssessmentComplete,
    AssessmentTasks,
    AssessmentOutcomeInstruction,
    AssessmentOutcomeItems,
} from '../components/assessment';

const AssessmentRoutesEnglishParent = [{
        path: '/Assessment/Instruction',
        component: AssessmentInstructionEnglishParent,
        monitorProgress: true
    }
]

const AssessmentRoutesEnglishTeacher = [{
    path: '/Assessment/Instruction',
        component: AssessmentInstructionEnglishTeacher,
        monitorProgress: true
}]

const AssessmentRoutesEnglishSelf = [{
    path: '/Assessment/Instruction',
        component: AssessmentInstructionEnglishSelf,
        monitorProgress: true
}]

const AssessmentRoutesFrenchParent = [{
    path: '/Assessment/Instruction',
        component: AssessmentInstructionFrenchParent,
        monitorProgress: true
}]

const AssessmentRoutesFrenchTeacher = [{
    path: '/Assessment/Instruction',
        component: AssessmentInstructionFrenchTeacher,
        monitorProgress: true
}]

const AssessmentRoutesFrenchSelf = [{
    path: '/Assessment/Instruction',
        component: AssessmentInstructionFrenchSelf,
        monitorProgress: true
}]

const AssessmentRoutesSpanishParent = [{
    path: '/Assessment/Instruction',
        component: AssessmentInstructionSpanishParent,
        monitorProgress: true
}]

const AssessmentRoutesSpanishSelf = [{
    path: '/Assessment/Instruction',
        component: AssessmentInstructionSpanishSelf,
        monitorProgress: true
}]

const AssessmentRoutesGlobal = [
    {
        path: '/Assessment/Omission',
        component: AssessmentOmission,
        monitorProgress: false
    },
    {
        path: '/Assessment/Complete',
        component: AssessmentComplete,
        monitorProgress: false
    }
]

export const TaskRoutes = [{
    path: '/Assessment/Tasks/:type/:segment?/:index?',
    component: AssessmentTasks,
    monitorProgress: true
}];

export const OutcomeRoutes = [{
        path: '/Assessment/Outcome/Instruction',
        component: AssessmentOutcomeInstruction,
        monitorProgress: true
    },
    {
        path: '/Assessment/Outcome/Items/:index?',
        component: AssessmentOutcomeItems,
        monitorProgress: true
    },
]

export const getAssessmentRoutesByID = (versionId) => {
    switch (parseInt(versionId)) {
        case 36:
        case 39:
        case 40:
        case 41:
        case 42:
        case 43:
            return [...AssessmentRoutesEnglishParent, ...AssessmentRoutesGlobal]
        case 37:
        case 56:
        case 57:
        case 58:
        case 59:
        case 60:
            return [...AssessmentRoutesEnglishTeacher, ...AssessmentRoutesGlobal]
        case 38:
        case 67:
        case 68:
        case 69:
        case 70:
        case 71:
            return [...AssessmentRoutesEnglishSelf, ...AssessmentRoutesGlobal]
        case 44:
        case 45:
        case 46:
        case 47:
        case 48:
        case 49:
            return [...AssessmentRoutesFrenchParent, ...AssessmentRoutesGlobal]
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
            return [...AssessmentRoutesSpanishParent, ...AssessmentRoutesGlobal]
        case 61:
        case 62:
        case 63:
        case 64:
        case 65:
        case 66:
            return [...AssessmentRoutesFrenchTeacher, ...AssessmentRoutesGlobal]
        case 72:
        case 73:
        case 74:
        case 75:
        case 76:
        case 77:
            return [...AssessmentRoutesFrenchSelf, ...AssessmentRoutesGlobal]
        case 78:
        case 79:
        case 80:
        case 81:
        case 82:
        case 83:
            return [...AssessmentRoutesSpanishSelf, ...AssessmentRoutesGlobal]
        default:
            return null;
    }
}

export const getAssessmentRoutes = (versionId) => {
    var routes = getAssessmentRoutesByID(versionId);

    return routes
}